/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const createChatMessageDataSchema = z.object({
	id: z.string().uuid().nullable().optional(),
	campaignId: z.string().uuid(),
	messages: z.array(
		z.object({
			role: z.union([z.literal('user'), z.literal('assistant'), z.literal('tool')]),
			id: z.string().nullable().optional(),
			parts: z.array(z.string()).nullable().optional(),
		}),
	),
	meta: z.array(z.string()).nullable().optional(),
	extraData: z.array(z.string()).nullable().optional(),
})

export type CreateChatMessageDataSchema = z.infer<typeof createChatMessageDataSchema>
